__turbopack_context__.v({
  "appCaption": "garageJunction-module__oBNehG__appCaption",
  "appImage": "garageJunction-module__oBNehG__appImage",
  "appItem": "garageJunction-module__oBNehG__appItem",
  "appStack": "garageJunction-module__oBNehG__appStack",
  "applicationsGrid": "garageJunction-module__oBNehG__applicationsGrid",
  "applicationsHeader": "garageJunction-module__oBNehG__applicationsHeader",
  "applicationsSection": "garageJunction-module__oBNehG__applicationsSection",
  "brandSection": "garageJunction-module__oBNehG__brandSection",
  "colorBlack": "garageJunction-module__oBNehG__colorBlack",
  "colorBlue": "garageJunction-module__oBNehG__colorBlue",
  "colorComposition": "garageJunction-module__oBNehG__colorComposition",
  "colorContent": "garageJunction-module__oBNehG__colorContent",
  "colorLabel": "garageJunction-module__oBNehG__colorLabel",
  "colorLabelDark": "garageJunction-module__oBNehG__colorLabelDark",
  "colorOrange": "garageJunction-module__oBNehG__colorOrange",
  "colorRed": "garageJunction-module__oBNehG__colorRed",
  "colorSection": "garageJunction-module__oBNehG__colorSection",
  "colorWhite": "garageJunction-module__oBNehG__colorWhite",
  "metaBlock": "garageJunction-module__oBNehG__metaBlock",
  "metaGrid": "garageJunction-module__oBNehG__metaGrid",
  "metaLabel": "garageJunction-module__oBNehG__metaLabel",
  "metaLeft": "garageJunction-module__oBNehG__metaLeft",
  "metaOverview": "garageJunction-module__oBNehG__metaOverview",
  "metaRight": "garageJunction-module__oBNehG__metaRight",
  "metaSection": "garageJunction-module__oBNehG__metaSection",
  "metaText": "garageJunction-module__oBNehG__metaText",
  "metaTools": "garageJunction-module__oBNehG__metaTools",
  "outcomesSection": "garageJunction-module__oBNehG__outcomesSection",
  "page": "garageJunction-module__oBNehG__page",
  "processSection": "garageJunction-module__oBNehG__processSection",
  "resultDetail": "garageJunction-module__oBNehG__resultDetail",
  "resultItem": "garageJunction-module__oBNehG__resultItem",
  "resultLabel": "garageJunction-module__oBNehG__resultLabel",
  "resultValue": "garageJunction-module__oBNehG__resultValue",
  "resultsContent": "garageJunction-module__oBNehG__resultsContent",
  "resultsGrid": "garageJunction-module__oBNehG__resultsGrid",
  "resultsSection": "garageJunction-module__oBNehG__resultsSection",
  "socialGrid": "garageJunction-module__oBNehG__socialGrid",
  "socialItem": "garageJunction-module__oBNehG__socialItem",
  "storySection": "garageJunction-module__oBNehG__storySection",
  "videoCaption": "garageJunction-module__oBNehG__videoCaption",
  "videoContainer": "garageJunction-module__oBNehG__videoContainer",
  "videoSection": "garageJunction-module__oBNehG__videoSection",
});
